import { apiClient } from '../../../shared/api/client.js';
import type { DashboardStats } from '../../../shared/types/index.js';

export const dashboardApi = {
  async getDashboardStats(role?: string): Promise<DashboardStats> {
    const query = role ? `?role=${encodeURIComponent(role)}` : '';
    return apiClient(`/api/stats/dashboard${query}`);
  },
  async getPublicStats(): Promise<DashboardStats> {
    return apiClient('/api/stats/public');
  },
};
